/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import useStyles from "./styles";
import InfoLoyalty from "./Components/InfoLoyalty";
import ContentLoyalty from "./Components/ContentLoyalty";
import ExplainLoyalty from "./Components/ExplainLoyalty";
import RemainingPoints from "./Components/RemainingPoints";
import TableLoyalty from "./Components/TableLoyalty";
import moment from "moment";

import { Grid } from "@material-ui/core";
import { connect } from "react-redux";
import {
	getLoyaltyPointDetailAction,
	setLoyaltyPointDetailAction
} from "store/actions/SpecialOfferPageAction";
import { useHistory } from "react-router-dom";

const LoyaltyDetailPage = props => {
	const classes = useStyles();
	const history = useHistory();
	const {
		getLoyaltyPointDetail,
		loyaltyPointDetail,
		setLoyaltyPointDetail,
		infoShop
	} = props;
	const idNotification = new URLSearchParams(history.location.search).get(
		"id"
	);
	const business = infoShop?.business || "THOPHAT";

	useEffect(() => {
		return () => {
			setLoyaltyPointDetail({});
		};
	}, []);

	useEffect(() => {
		if (idNotification) {
			const data = {
				business: business,
				loyaltyId: idNotification
			};
			getLoyaltyPointDetail(data);
		} else {
			history.push("/home");
		}
	}, [idNotification]);

	const checkDisableBtnChangeGift = loyalty => {
		const startTime = moment(
			loyalty?.startTimeReward,
			"DD/MM/YYYY"
		).startOf("day");
		const endTime = moment(loyalty?.endTimeReward, "DD/MM/YYYY").endOf(
			"day"
		);
		const currentTime = moment();

		if (currentTime.isBetween(startTime, endTime)) {
			return false;
		}
		return true;
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.bannerYellow }}>
				<RemainingPoints loyaltyDetail={loyaltyPointDetail} />
				<InfoLoyalty loyaltyDetail={loyaltyPointDetail} />
			</Grid>
			<Grid style={{ padding: 16 }}>
				<ContentLoyalty />
				<TableLoyalty
					loyaltyProductMappings={
						loyaltyPointDetail?.loyaltyProductMappings
					}
				/>
				<ExplainLoyalty />
				<Grid
					classes={{ root: classes.btnDefault }}
					component="button"
					style={{
						background:
							checkDisableBtnChangeGift(loyaltyPointDetail) &&
							"#d3d3d3",
						cursor:
							!checkDisableBtnChangeGift(loyaltyPointDetail) &&
							"pointer"
					}}
					disabled={checkDisableBtnChangeGift(loyaltyPointDetail)}
					onClick={() => {
						history.push(`/gift_exchange?id=${idNotification}`);
					}}
				>
					Đổi quà ngay
				</Grid>
			</Grid>
		</Grid>
	);
};

const mapStateToProps = state => {
	return {
		loyaltyPointDetail: state.specialOfferPageReducer.loyaltyPointDetail,
		infoShop: state.homePageReducer.infoShop
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getLoyaltyPointDetail: data => {
			dispatch(getLoyaltyPointDetailAction(data));
		},
		setLoyaltyPointDetail: data => {
			dispatch(setLoyaltyPointDetailAction(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(LoyaltyDetailPage);
